import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { ChangeDetectorRef, Component, ElementRef, TemplateRef } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { serverError } from './../../../../core/models/messages';
import { ProjetService } from './../../../../core/services/projet-service/projet.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';

export function dateRangeValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const startDate = group.get('start_date')?.value;
    const endDate = group.get('end_date')?.value;

    if (startDate && endDate && moment(startDate).isAfter(endDate)) {
      return {
        dateRangeError:
          'La date début ne doit pas être supérieure à la date fin.',
      };
    }

    return null;
  };
}

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.css'],
})
export class ProjectComponent {
  id: any;
  listprojet: any;
  totalItems!: number;
  membres: any=[]
  listresponsables: any;
  membreslist: any = [];
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  formprojet!: FormGroup;
  sortAttr = '';
  modalRef?: BsModalRef;
  searchForm: FormGroup = this.createSearchForm();
  pagination : boolean =false;

  currentSortColumn: string = 'name'; // Initial column to sort by
  constructor(
    private formBuilder: FormBuilder,
    private projetservice: ProjetService,
    private router: Router,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private sortDataService: SortDataService,
    private localStorageService: LocalStorageService,
    private modalService: BsModalService,
    private cdRef: ChangeDetectorRef,
    private elRef: ElementRef,
  ) {}

  ngOnInit() {
    console.log(this.localStorageService.getData('clientConnected'));
    console.log('bonjour wegestu');
    this.getListprojet();
    this.getListresponsable();
    this.getListmembre();
    this.formprojet = this.formBuilder.group(
      {
        client_id: [''],
        name: ['', [Validators.required]],
        membres: [null],
        manager_id: [],
        start_date: [''],
        end_date: [''],
      },
      { validator: dateRangeValidator() }
    );

    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
   
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
      console.log('HEYYYYYYYYYYYY');
    }
  }
  sortData(item: string) {
    console.log('item', item);
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
   
    console.log('form', this.searchForm.value);
    if (this.searchForm.dirty)
      this.listprojet = this.sortDataService.sortArray(
        this.listprojet,
        item,
        this.currentSortDirection
      );
    else this.getListprojet();
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true
          this.getListprojet();
        }
    }
  }

  getresponsable(selectedManagerId: any) {
    let data = [];
    for (const iterator of this.membres) {
        if (selectedManagerId.id == iterator.id) {
          data.push(iterator);
        }
      } 
      console.log("data",data)
      this.formprojet.get('membres')?.setValue([data[0].consultant_client_finals_id]);
    console.log('this updateform : ', this.formprojet.value);
    
  }
  
  
  
  getListprojet() {
    this.id = this.localStorageService.getData('clientConnected');
    let dataPyload =
      this.sortAttr == ''
        ? { id: this.id, per_page: this.itemsPerPage, page: this.currentPage }
        : {
            ...{
              id: this.id,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    console.log('data', dataPyload);
    this.spinner.show();
    this.projetservice.getListprojet(dataPyload).subscribe({
      next: (response) => {
        console.log('response projet', response);
        if (response.data && response.data.data) {
          this.listprojet = response.data.data.reverse();
          // .slice(0, this.endIndex);
          this.totalItems = response.data.total;
          
          this.spinner.hide();
          console.log('list projet', this.listprojet);
        }
      },
      error: (error) => {
        this.spinner.hide();
        console.error('Error fetching projet: ', error);
      },
    });
  }
  getListmembre() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.projetservice.getmembre(this.idclientConnected).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data) {
          this.membres = response.data;
          this.listresponsablesWithDisplayName1();
          console.log('list membre', this.membres);
        }
      },
      error: (error) => {
        console.error('Error fetching membre: ', error);
      },
    });
  }

  getListresponsable() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

    this.projetservice.getlistRoles(this.idclientConnected).subscribe({
      next: (response) => {
        console.log('response responsable', response);
        if (response.data) {
          this.listresponsables = response.data;
          this.listresponsablesWithDisplayName();
          console.log(' listresponsables', this.listresponsables);
          console.log(
            'id responsable',
            this.listresponsables[0].consultant_client_finals_id
          );
        }
      },
      error: (error) => {
        console.error('Error fetching responsable: ', error);
      },
    });
  }
  listresponsablesWithDisplayName() {
    this.listresponsables.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  listresponsablesWithDisplayName1() {
    this.membres.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  supprimer(id: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer ce projet ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, Supprimer !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.projetservice.supprimer(id).subscribe({
          next: (response: any) => {
            console.log('response', response);

            console.log('response.data', response.data);
            this.toastrService.success(
              'Le projet  a été supprimé avec succès .'
            );
            this.searchprojet();
          },
          error: (error: any) => {
            console.error('Error fetching  job offer: ', error);
          },
        });
      }
    });
  }
  disabledcloture: boolean = false;
  isProcessing: boolean = false;
  closeProjet(id: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment clôturer ce projet ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, Clôturer !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.projetservice.closeprojet(id).subscribe({
          next: (response: any) => {
            console.log('response', response);
            console.log('response.data', response.data);
            this.toastrService.success('Le projet a été clôturé avec succès.');
            this.searchprojet();
            this.disabledcloture = true; // Assurez-vous que cette ligne est exécutée
          },
          error: (err) => {
            if (err?.error) {
              if (err?.error?.message === "Project already closed") {
                this.disabledcloture = true;
                this.toastrService.error("Projet déjà fini");
              } else {
                this.toastrService.error("Une erreur serveur s'est produite.");
              }
            }
          },
          complete: () => {
            this.cdRef.detectChanges(); 
          }
        });
      }
    });
  }

  createprojet() {
    this.formprojet.markAllAsTouched();
    this.formprojet.markAsDirty();
    const membres = this.formprojet.get('membres')?.value;
    console.log('membres', membres);
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.formprojet.patchValue({
      client_id: this.idclientConnected,
    });
    console.log('start date', this.formprojet.value.start_date);
    console.log('end date', this.formprojet.value.end_date);
    console.log('client_id', this.idclientConnected);
    console.log('manager_id', this.formprojet.value.manager_id);
    console.log(
      'consultant',
      this.formprojet.value.consultant_client_finals_id
    );

    if (this.formprojet.invalid) {
      return;
    }

    console.log('form', this.formprojet.value);
    this.projetservice.createprojet(this.formprojet.value).subscribe({
      next: (response) => {
        console.log('add projet', response);
        this.toastrService.success('projet est ajouté avec succés ');
        this.getListprojet();
        this.disabledcloture = false; 
        this.close_modal_add();
      },
      error: (error) => {
        console.error('Error fetching add projet: ', error);
        if (
          error.status === 400 ||
          (error.data && error.data.name) ||
          error.data.name[0] === 'The name has already been taken.'
        ) {
          this.toastrService.info('Le nom du projet existe déjà.');
        } else {
          this.toastrService.error(
            "Une erreur s'est produite lors de la création du projet."
          );
        }
      },
    });
  }

  openModaladd(template: TemplateRef<any>, data?: any, mode?: string) {
    // this.formconsultant.reset();
    // this.formconsultant.get('email')?.setValue('');
    // this.selectedconsultant = '';
    // this.errorMessage = '';
    // console.log("membres(0)",this.membres[0])
    // this.formprojet.get('membres')?.setValue([this.membres[0].consultant_client_finals_id]);
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  close_modal_add() {
  
    this.formprojet.reset();

    this.cdRef.detectChanges();
    let btnClose = document.getElementById('ModalClose_add_consultant');

    console.log('btnClose', btnClose);
    if (btnClose) {
      btnClose.click();
      this.formprojet.reset();
  
      this.cdRef.detectChanges();
    }

    if (this.modalRef && typeof this.modalRef.hide === 'function') {
      this.modalRef.hide();
    }
  }

  gotodetail(id: any) {
    console.log('id projet', id);
    this.router.navigate(['/projets/detail-projets/' + id]);
  }
  resetform() {
    this.formprojet.reset();
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_project: ['', data?.ID_project],
      name: ['', data?.name],
      membre_name: ['', data?.membre_name],
    });
  }
  searchprojet() {
    let valueForm = this.searchForm.value;
    let data = {
      id: this.localStorageService.getData('clientConnected'),
      name: valueForm.name,
      ID_project: valueForm.ID_project,
      membre_name: valueForm.membre_name,
      per_page: this.itemsPerPage,
      page: this.currentPage,
    };
    console.log('data', data);
    this.spinner.show();
    this.projetservice.searchprojet(data).subscribe({
      next: (resSearch) => {
        console.log('resSearch', resSearch);
        if ( this.currentPage > 1) {
          this.currentPage = 1;
          this.searchprojet();
          this.spinner.hide();
          console.log('response search', resSearch);
        } else {
          this.listprojet = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        }
      },
      error: (error) => {
        console.log(error);
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchprojet();
  }
}
